import { render, staticRenderFns } from "./SupplierSummary.vue?vue&type=template&id=7ce2b152&"
import script from "./SupplierSummary.vue?vue&type=script&lang=js&"
export * from "./SupplierSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports